// IMOTEpS — Centre de recherche / Chapitre 5
// Auto-split from chapters.js (Feb 2026 refactor)

export const chapter05 = {
  id: 5,
  slug: "coiffe-rotateurs",
  color: "#B5682A",
  title: "Ruptures de la coiffe des rotateurs",
  subtitle: "Anatomie, classification, traitement chirurgical et conservateur",
  region: "Épaule",
  readingMin: 18,
  summary:
    "Anatomie de la coiffe (sus-épineux, sous-épineux, petit rond, sous-scapulaire), zone critique de Codman, classification des ruptures, examen clinique (Jobe, Patte, Gerber, Neer, Hawkins), imagerie (radio/écho/IRM) et indications chirurgicales par arthroscopie.",
  sections: [
    {
      heading: "1. Anatomie & vascularisation",
      body: "La coiffe des rotateurs regroupe quatre tendons issus de la scapula et qui s'insèrent sur le tubercule majeur et mineur de l'humérus. La zone critique de Codman, à 1 cm de l'insertion du sus-épineux, est la zone de moindre vascularisation et le siège préférentiel des ruptures dégénératives.",
    },
    {
      heading: "2. Classification des ruptures",
      body: "Les ruptures se classent selon leur taille (< 1 cm, 1–3 cm, 3–5 cm, > 5 cm — classification de De Orio & Cofield), leur épaisseur (partielle articulaire, partielle bursale, transfixiante) et le nombre de tendons concernés. La rétraction tendineuse (classification de Patte) et la dégénérescence graisseuse (Goutallier) conditionnent le pronostic.",
    },
    {
      heading: "3. Examen clinique",
      list: [
        "Test de Jobe : abduction 90° + antéversion 30° + rotation interne, résistance vers le bas",
        "Test de Patte : rotation externe contrariée, coude au corps puis abduction 90°",
        "Test de Gerber (lift-off) : main dans le dos, décollement contrarié",
        "Test de Neer & Hawkins : signes de conflit sous-acromial",
      ],
    },
    {
      heading: "4. Imagerie",
      body: "La radiographie de face en rotation neutre, profil de Lamy et Bernageau évalue l'espace sous-acromial (< 7 mm = signe de rupture massive) et l'arthrose éventuelle. L'échographie dynamique reste un examen de première intention performant. L'IRM est l'examen de référence pour quantifier rétraction et dégénérescence graisseuse.",
    },
    {
      heading: "5. Traitement conservateur vs chirurgical",
      body: "Le traitement conservateur (rééducation excentrique, infiltrations parcimonieuses, antalgiques) est tenté pendant 3 à 6 mois pour les ruptures dégénératives non massives. La chirurgie arthroscopique avec ancres résorbables est indiquée chez le sujet jeune actif, le sportif ou en cas d'échec du traitement médical.",
    },
    {
      heading: "6. Réflexion personnelle — au-delà du conflit mécanique",
      body: "Les modèles purement mécaniques ne suffisent plus à expliquer la diversité des présentations cliniques. Les facteurs génétiques (polymorphismes SCN9A/Nav1.7 modulant la perception douloureuse, COMT) et la sensibilisation centrale jouent un rôle majeur, notamment dans la dissociation entre image radiologique et douleur. Mes observations cliniques montrent que les chutes sur le coude provoquent plus fréquemment des ruptures de coiffe que les chutes directes sur l'épaule, par effet d'arrachement axial.",
    },
  ],
  references: [
    { id: 1, text: "Codman EA. The Shoulder. Boston: Thomas Todd; 1934." },
    { id: 2, text: "Goutallier D, Postel JM, Bernageau J, et al. Fatty muscle degeneration in cuff ruptures. Clin Orthop. 1994;304:78-83.", pubmed: "8020238" },
    { id: 3, text: "Aswad R. Observations cliniques sur le mécanisme lésionnel de la coiffe par chute sur le coude. Communication SOFCOT 2018." },
  ],
};
